import { render, staticRenderFns } from "./RecentFeedHistoryDropdown.vue?vue&type=template&id=c84c30cc&scoped=true"
import script from "./RecentFeedHistoryDropdown.vue?vue&type=script&lang=js"
export * from "./RecentFeedHistoryDropdown.vue?vue&type=script&lang=js"
import style0 from "./RecentFeedHistoryDropdown.vue?vue&type=style&index=0&id=c84c30cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84c30cc",
  null
  
)

export default component.exports